<template>
    <div class="py-2 px-1.5">
        <label :for="spec.id+content.value" class="flex items-center cursor-pointer group">
            <span
                class="inline-block rounded-full w-[40px] h-[40px] mr-1.5 outline-offset-2 outline-secondary duration-100 transition-all bg-cover bg-center"
                :class="[is_selected(content.value) ? 'outline-[3px] outline' : 'group-hover:outline-[3px] group-hover:outline']"
                :style="'image' in content ? { 'background-image': 'url(' + content?.image + ')' } : ''"></span>
            <span>{{ content.name }}
            <span v-if="content.count" class="bg-secondary text-white rounded-full px-2 py-1">{{ content.count }}</span>
        </span>
        </label>
    </div>
</template>

<script>

export default {
    name: "images",
    props: ['spec', 'content'],
    methods: {
        is_selected: function (val) {
            return new URL(window.location.href).searchParams.getAll(util.format('s%s[]', this.$props.spec.id)).filter(v => v === (val + '')).length > 0;
        }
    },
}
</script>

<style scoped>

</style>
